'use strict';

import React from 'react';
import { createHeaderStore } from '../../redux/store';
import { renderComponent } from '@src/utils/renderer/client-renderer';
import { HeaderLayout } from '../../views/layouts/header';
import { pick } from 'lodash';

const APP_ID = 'header-section';
const app = document.getElementById(APP_ID);

if (app && window.USE_LEGACY_HEADER_FOOTER_REDUX === 'true') {
    const store = createHeaderStore(
        pick(window.REDUX_DATA, ['userReducer', 'panelsReducer', 'marketplaceReducer', 'inboxReducer', 'cartReducer'])
    );

    renderComponent(<HeaderLayout />, {
        appId: APP_ID,
        store,
        enableQueryClient: true
    });
}
